module.exports = __webpack_public_path__ + "img/events_empty_new.6fcabff2.svg";